import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import alertIcon from '../../src/img/warning-icon.svg'
import { Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: '1.5em',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export default function BasicModalInformation(props) {

  function localOnClick() {
    props.onClick && props.onClick();
    props.handleClose();
  }

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src={alertIcon} alt='alert icon' height='32px' />
          <Typography id="modal-modal-description" sx={{ mt: 2 }} align="center">
            {props.title || "Duis mollis, est non commodo luctus, nisi erat porttitor ligula."}
          </Typography>

          <div className='basic-modal-button'>
            <Button variant='contained' style={{ width:'100px' }} onClick={localOnClick}>OK</Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}